export default __webpack_public_path__ + "bg40eed66.png";